"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceInformationREFLoopToJSON = exports.ReferenceInformationREFLoopFromJSONTyped = exports.ReferenceInformationREFLoopFromJSON = exports.instanceOfReferenceInformationREFLoop = void 0;
var ConsolidatedShipmentManifestDataSMD_1 = require("./ConsolidatedShipmentManifestDataSMD");
var ExtendedReferenceInformationN9_1 = require("./ExtendedReferenceInformationN9");
var MotorVehicleControlVC_1 = require("./MotorVehicleControlVC");
var QuantityAndDescriptionN10_1 = require("./QuantityAndDescriptionN10");
var ReferenceInformationREF_1 = require("./ReferenceInformationREF");
/**
 * Check if a given object implements the ReferenceInformationREFLoop interface.
 */
function instanceOfReferenceInformationREFLoop(value) {
    return true;
}
exports.instanceOfReferenceInformationREFLoop = instanceOfReferenceInformationREFLoop;
function ReferenceInformationREFLoopFromJSON(json) {
    return ReferenceInformationREFLoopFromJSONTyped(json, false);
}
exports.ReferenceInformationREFLoopFromJSON = ReferenceInformationREFLoopFromJSON;
function ReferenceInformationREFLoopFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reference_information_REF': json['reference_information_REF'] == null ? undefined : (0, ReferenceInformationREF_1.ReferenceInformationREFFromJSON)(json['reference_information_REF']),
        'extended_reference_information_N9': json['extended_reference_information_N9'] == null ? undefined : (json['extended_reference_information_N9'].map(ExtendedReferenceInformationN9_1.ExtendedReferenceInformationN9FromJSON)),
        'quantity_and_description_N10': json['quantity_and_description_N10'] == null ? undefined : (json['quantity_and_description_N10'].map(QuantityAndDescriptionN10_1.QuantityAndDescriptionN10FromJSON)),
        'consolidated_shipment_manifest_data_SMD': json['consolidated_shipment_manifest_data_SMD'] == null ? undefined : (0, ConsolidatedShipmentManifestDataSMD_1.ConsolidatedShipmentManifestDataSMDFromJSON)(json['consolidated_shipment_manifest_data_SMD']),
        'motor_vehicle_control_VC': json['motor_vehicle_control_VC'] == null ? undefined : (json['motor_vehicle_control_VC'].map(MotorVehicleControlVC_1.MotorVehicleControlVCFromJSON)),
    };
}
exports.ReferenceInformationREFLoopFromJSONTyped = ReferenceInformationREFLoopFromJSONTyped;
function ReferenceInformationREFLoopToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'reference_information_REF': (0, ReferenceInformationREF_1.ReferenceInformationREFToJSON)(value['reference_information_REF']),
        'extended_reference_information_N9': value['extended_reference_information_N9'] == null ? undefined : (value['extended_reference_information_N9'].map(ExtendedReferenceInformationN9_1.ExtendedReferenceInformationN9ToJSON)),
        'quantity_and_description_N10': value['quantity_and_description_N10'] == null ? undefined : (value['quantity_and_description_N10'].map(QuantityAndDescriptionN10_1.QuantityAndDescriptionN10ToJSON)),
        'consolidated_shipment_manifest_data_SMD': (0, ConsolidatedShipmentManifestDataSMD_1.ConsolidatedShipmentManifestDataSMDToJSON)(value['consolidated_shipment_manifest_data_SMD']),
        'motor_vehicle_control_VC': value['motor_vehicle_control_VC'] == null ? undefined : (value['motor_vehicle_control_VC'].map(MotorVehicleControlVC_1.MotorVehicleControlVCToJSON)),
    };
}
exports.ReferenceInformationREFLoopToJSON = ReferenceInformationREFLoopToJSON;
